import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { Card, CardContent } from '@/components/ui/card'
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/select'

import { ProgramFilters, ProgramType } from './program.types'

interface ProgramsFilterProps {
  filters: ProgramFilters
  onFiltersChange: (filters: Partial<ProgramFilters>) => void
  onAddClick: () => void
}

const PROGRAM_TYPE_TABS = [
  { label: 'แอดมิน', value: ProgramType.ADMIN },
  { label: 'ผู้ใช้', value: ProgramType.USER },
] as const

export default function ProgramsFilter({
  filters,
  onFiltersChange,
  onAddClick,
}: ProgramsFilterProps) {
  // Handler สำหรับเปลี่ยน ProgramType
  const handleProgramTypeChange = (type: ProgramType) => {
    onFiltersChange({
      type,
      page: 1,
    })
  }

  return (
    <Card>
      <CardContent>
        <div className="flex flex-col gap-6">
          {/* Header with Add Button */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-black">จัดการโปรแกรม</h2>
            <Button onClick={onAddClick}>เพิ่มโปรแกรม</Button>
          </div>

          <Separator className="border-gray-200" />

          <div className="flex gap-6 flex-wrap">
            {/* Program Type Filter */}
            <div className="space-y-1">
              <p className="text-sm font-medium text-gray-500 mb-1">
                ประเภทโปรแกรม
              </p>
              <Select
                value={String(filters.type)}
                onValueChange={(value) =>
                  handleProgramTypeChange(value as ProgramType)
                }
              >
                <SelectTrigger className="min-w-[140px]">
                  <SelectValue placeholder="เลือกประเภทโปรแกรม" />
                </SelectTrigger>
                <SelectContent>
                  {PROGRAM_TYPE_TABS.map((tab) => (
                    <SelectItem
                      key={String(tab.value)}
                      value={String(tab.value)}
                    >
                      {tab.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
